import { render, staticRenderFns } from "./DomicilioEntregaOriginales.vue?vue&type=template&id=99e4862a"
import script from "./DomicilioEntregaOriginales.vue?vue&type=script&lang=js"
export * from "./DomicilioEntregaOriginales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e4862a')) {
      api.createRecord('99e4862a', component.options)
    } else {
      api.reload('99e4862a', component.options)
    }
    module.hot.accept("./DomicilioEntregaOriginales.vue?vue&type=template&id=99e4862a", function () {
      api.rerender('99e4862a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/infoBase/DomicilioEntregaOriginales.vue"
export default component.exports